/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-35
 */

"use strict"

import * as /* [auto-meaningful-name] */Src_shared_packages_Crc_blink_src_index from /* 17 */"../../../../src/shared/packages/@crc/blink/src/index"
import * as /* [auto-meaningful-name] */Module_33 from /* 33 */"./33"
var /* [auto-meaningful-name] */SepGap_50__sep = "<sep gap=\"50\"></sep>"
export { SepGap_50__sep as $d }
